import React from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import { ForgotModal, LoginModal, ResetModal } from "fragments";
import { IsImageLoaded } from "utils";
import { Images } from "assets";

export function LoginPage() {
  const { search, pathname } = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(search);
  const resetToken = searchParams.get("resetToken");
  const registerToken = searchParams.get("token");
  const userEmail = searchParams.get("email");
  const imageLoaded = IsImageLoaded(Images.authImage);

  const renderScreen = () => {
    if (pathname === "/forgot") {
      return <ForgotModal />;
    } else {
      if (registerToken || userEmail || resetToken) {
        return <ResetModal />;
      } else {
        return <LoginModal />;
      }
    }
  };

  return (
      <div className="auth-page-wrapper ">
          <div className="auth-page_left-side">
              <img
                  src={Images.authImageSmall}
                  alt="Auth Image"
                  style={{
                      opacity: imageLoaded ? 0 : 1,
                      transition: "opacity 0.5s ease-in-out",
                      visibility: imageLoaded ? "hidden" : "visible",
                  }}
              />
              <img
                  src={Images.authImage}
                  alt="Auth Image"
                  style={{
                      opacity: imageLoaded ? 1 : 0,
                      transition: "opacity 0.5s ease-in-out",
                      visibility: imageLoaded ? "visible" : "hidden",
                  }}
              />
          </div>

          <div className="auth-page_right-side">
              <div
                  className="right-side-logo"
                  onClick={() => {
                      navigate("/");
                  }}
              >
                  <img src={Images.logoImg} alt="logo"/>
              </div>

              <div className="auth-page_right-side_content">{renderScreen()}</div>
              <a href="/privacy" target={'_blank'} style={{ position:'absolute', bottom: 24 }} className="privacy-link">
                  Privacy
              </a>
          </div>
      </div>
  );
}
